import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const ListPage = React.lazy(() => import("@mediaspace/features/list-page"));

export const render = getDsLayoutComponentRenderer(ListPage);
